import React from 'react';
import {Segment,Header,Button, List}  from 'semantic-ui-react'

const SelectSize=(props)=>
{

    
  const {kunde,click}=props


  return ( <>  
      {
       kunde && kunde.Modus==='manuell' ?
          <Segment style={{'margin-top':'3rem'}}>
              <Button size='big' name='OK' icon='check' onClick={click} icon='box' content='OK' color='green'/>
          </Segment>

        :
          <Segment style={{'margin-top':'3rem'}}>
            <Header as='h2'>Paketgrösse wählen</Header>
            <List textAlign='center'>
              <List.Item key='S'>
                    <Button size='big' name='S' onClick={click} icon='box' content='S' color='green'/>
              </List.Item>
              <List.Item key='M'>
                  <Button size='big' name='M' onClick={click} icon='box' content='M' color='green'/> 
              </List.Item>
        
              <List.Item key='L'>
                    <Button size='big' name='L' icon='box' onClick={click} content='L' color='green'/>
              </List.Item>
              <List.Item key='X'>
                  <Button size='big' name='XL' onClick={click} icon='box' content='XL' color='green'/> 
              </List.Item>
            </List>
          </Segment>
      }
    </>)
}
export default SelectSize
